var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOpen)?_c('button',{staticClass:"btn-close p-0 w-9 h-9 bg-expovina-orange rounded-full hover:bg-red-700 transition ease-in duration-200 focus:outline-none",on:{"click":_vm.toggleAsideMenu}},[_c('b-icon-x',{staticClass:"align-middle"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }